import classNames from 'classnames';
import React from 'react';
import { TextInput } from 'ui';
import { Props as BaseProps } from 'ui/components/form/BaseInput';

type Props = React.DetailedHTMLProps<
  React.InputHTMLAttributes<HTMLInputElement> &
    BaseProps & {
      id: string;
      label: string;
      wrapperClassName?: string;
      dataTestId?: string;
    },
  HTMLInputElement
>;

export const TextField = React.forwardRef<HTMLInputElement, Props>(
  ({ className, wrapperClassName, label, id, dataTestId, ...props }, ref) => {
    return (
      <fieldset className={wrapperClassName}>
        <label
          htmlFor={id}
          className="block text-sm font-medium text-gray-dark400 mb-3"
        >
          {label}
        </label>
        <TextInput
          id={id}
          className={classNames(
            'mt-2 focus:ring-primary focus:border-primary block w-full sm:text-sm border-gray-dark500 bg-gray-dark600 shadow-none rounded-md hover:border-primary placeholder-gray-dark500 focus-within:text-gray-dark400 text-gray-dark500',
            className
          )}
          ref={ref}
          data-testid={dataTestId}
          {...props}
        />
      </fieldset>
    );
  }
);

export default TextField;
